import { Dropdown } from "semantic-ui-react";

import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

import useHasRight from "../../../../authorization/hooks/useHasRight";

import { getAgreementSecondPartyAdminURL } from "../../../utils/agreementsHelper";

export default function ViewAgreementSecondPartyDropdownItem({ agreement }) {
	const { t } = useTranslation();
	const hasRight = useHasRight();

	if (!hasRight("agreements.view")) {
		return null;
	}

	return (
		<Dropdown.Item
			as={agreement ? Link : null}
			to={getAgreementSecondPartyAdminURL(agreement)}
			disabled={!agreement}
		>
			{t("viewSecondParty", "View second party")}
		</Dropdown.Item>
	);
}
